
import { defineComponent } from 'vue';

/**
 * vue-infinite-loading でエラーが発生した際に表示するコンポーネント
 */
export default defineComponent({
  name: 'InfiniteLoadingError',
});
